import { Box, Grid2, IconButton, InputLabel, MenuItem, Select, TextField, Tooltip, Typography, useMediaQuery, useTheme } from "@mui/material";
import * as Yup from 'yup'
import { yupResolver } from '@hookform/resolvers/yup';
import { Controller, useForm } from "react-hook-form";
import { useContext, useEffect, useState } from "react";
import MUIButton from "../../reusable_components/components/MUIButton";
import MUICancelButton from "../../reusable_components/components/MuiCancelButton";
import { Link, useNavigate, useParams } from "react-router-dom";
import { useAdminCoordinatorSaveMutation, useViewAdminByIdMutation } from "../../redux/Admin/AddAdmin.api";
import { useSelector } from "react-redux";
import { SnackbarContext } from "../../reusable_components/components/Snackbar";
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import DoneIcon from '@mui/icons-material/Done';
import Loader from "../../reusable_components/components/Loader";
import ClearIcon from '@mui/icons-material/Clear';

const AddAdmin = () => {

    const { Snackbar } = useContext(SnackbarContext)
    const params = useParams();

    const navigate = useNavigate()
    const theme = useTheme()
    const isSmallScreen = useMediaQuery(theme.breakpoints.down('md'))

    const [coordinatorId, setCoordinatorId] = useState()

    const [isButton, setIsButton] = useState(false)

    // APIs 
    const [adminCoordinatorSave] = useAdminCoordinatorSaveMutation()
    const [ViewAdminById, { data: getAdminById }] = useViewAdminByIdMutation()

    const [showLoader, setShowLoader] = useState(false)
    const [openSelect, setOpenSelect] = useState(false)
    const [openStatus, setOpenStatus] = useState(false)

    const validationSchema = Yup.object().shape({
        firstName: Yup.string().required('First Name is required')
            .matches(/^[A-Za-z\s]+$/, 'must only contain letters'),

        city: Yup.string().required('City is required')
            .matches(/^[A-Za-z\s]+$/, 'must only contain letters'),

        pincode: Yup.string().required("Pincode is required").min(6, 'Enter valid 6 Digit pincode').max(6, 'Enter valid 6 Digit pincode'),
        mobile: Yup.string().required("Contact Number is required"),

        lastName: Yup.string().required("Last Name is required")
            .matches(/^[A-Za-z\s]+$/, 'must only contain letters'),

        street: Yup.string().required("Street/Building is required"),

        state: Yup.string().required("State is required")
            .matches(/^[A-Za-z\s]+$/, 'must only contain letters'),

        email: Yup.string().required("Email Id is required"),

        userType: Yup.string().required("User Type is required"),

        statusType: Yup.string().required("Status Type is required")
    })

    const resolver = yupResolver(validationSchema)

    const {
        control,
        handleSubmit,
        reset,
        formState: { errors }
    } = useForm({
        resolver,
        mode: 'onChange',
        defaultValues: {
            firstName: "",
            mobile: "",
            city: "",
            pincode: "",
            lastName: "",
            street: "",
            state: "",
            email: "",
            userType: "",
            statusType: ""
        }
    })

    const onSubmit = async (data) => {
        if (role === "coordinator") {
            Snackbar("Not Authorized", 'error')
        } else {
            if (!editId) {
                try {
                    const payload = {
                        address: data?.street,
                        city: data?.city,
                        coordinatorId: "",
                        email: data?.email,
                        firstName: data?.firstName,
                        lastName: data?.lastName,
                        mobile: data?.mobile,
                        password: "",
                        pincode: data?.pincode,
                        state: data?.state,
                        status: +data?.statusType,
                        type: +data?.userType
                    }
                    setShowLoader(true)
                    const response = await adminCoordinatorSave(payload).unwrap()
                    setShowLoader(false)
                    if (response?.data?.error_code) {
                        Snackbar(response?.data?.error_message, 'error')
                        setShowLoader(false)
                    } else if (response?.response?.message) {
                        Snackbar(response?.response?.message, 'success')
                        setShowLoader(false)
                        navigate('/admin')
                    }
                    if (response?.data?.error_code === "403") {
                        Snackbar("Not Authorized", 'error')
                        setShowLoader(false)
                    }
                } catch (error) {
                    Snackbar("Network error", 'error')
                    setShowLoader(false)
                }
            } else {
                if (role === "coordinator") {
                    Snackbar("Not Authorized", 'error')
                    setShowLoader(false)
                } else {
                    try {
                        const payload = {
                            address: data?.street,
                            city: data?.city,
                            coordinatorId: editId,
                            email: data?.email,
                            firstName: data?.firstName,
                            lastName: data?.lastName,
                            mobile: data?.mobile,
                            password: "",
                            pincode: data?.pincode,
                            state: data?.state,
                            status: +data?.statusType,
                            type: +data?.userType
                        }
                        setShowLoader(true)
                        const response = await adminCoordinatorSave(payload).unwrap()
                        setShowLoader(false)
                        if (response?.data?.error_code) {
                            Snackbar(response?.data?.error_message, 'error')
                            setShowLoader(false)
                        } else if (response?.response?.message) {
                            Snackbar(response?.response?.message, 'success')
                            setShowLoader(false)
                            navigate('/admin')
                        }
                        if (response?.data?.error_code == "403") {
                            Snackbar("Not Authorized", 'error')
                            setShowLoader(false)
                        }
                    } catch (error) {
                        Snackbar("Network error", 'error')
                        setShowLoader(false)
                    }
                }
            }
        }
    }

    const editId = +params?.id

    const { Profile } = useSelector((state) => state.common)
    const role = Profile?.profile?.role

    useEffect(() => {
        if (editId) {
            const payload = {
                coordinatorId: editId
            }
            ViewAdminById(payload);
            setIsButton(true)
            setCoordinatorId(editId)
        }

    }, [editId, ViewAdminById])

    useEffect(() => {
        if (getAdminById) {
            const defaultValues = {
                firstName: getAdminById?.response?.data[0]?.firstName,
                mobile: getAdminById?.response?.data[0]?.mobile,
                city: getAdminById?.response?.data[0]?.city,
                pincode: getAdminById?.response?.data[0]?.pincode,
                lastName: getAdminById?.response?.data[0]?.lastName,
                street: getAdminById?.response?.data[0]?.address,
                state: getAdminById?.response?.data[0]?.state,
                email: getAdminById?.response?.data[0]?.email,
                userType: getAdminById?.response?.data[0]?.userType,
                statusType: getAdminById?.response?.data[0]?.status

            }
            reset({
                ...defaultValues,
            });

        }

    }, [getAdminById, reset])

    const userTypeOptions = [
        {
            id: "1",
            label: "Admin"
        },
        {
            id: "0",
            label: "Coordinator"
        },
    ]

    const statusOptions = [
        {
            id: '1',
            label: 'Active'
        },
        {
            id: '0',
            label: 'Inactive'
        }
    ]

    return (
        <Box className="container">
            {showLoader ? <Loader /> : ""}
            <Typography className="title" sx={{ marginLeft: '10%' }}>Admin/Coordinator Details</Typography>
            <form onSubmit={handleSubmit(onSubmit)}>
                <Box sx={{ display: 'flex', justifyContent: 'center' }}>
                    <Box className='formBox'>
                        <Grid2 container sx={{ display: 'flex', justifyContent: 'space-between', flexDirection: !isSmallScreen ? 'row' : 'column' }}>
                            <Grid2 item container rowGap={2} sx={{ display: 'flex', flexDirection: 'column', width: !isSmallScreen ? '40%' : '100%' }}>
                                {isButton ? (<Grid2 item sx={{ alignItems: 'center' }}>
                                    <InputLabel className='inputlabels'>User Id<span style={{ color: 'red' }}>*</span></InputLabel>
                                    <TextField
                                        className='textfields'
                                        variant="outlined"
                                        type="text"
                                        size="small"
                                        sx={{
                                            "& .MuiFormHelperText-root": {
                                                marginLeft: '-1px'
                                            }
                                        }}
                                        value={coordinatorId}
                                        disabled
                                    />
                                </Grid2>) : ("")
                                }

                                {/* original name */}
                                <Grid2 item sx={{ alignItems: 'center' }}>
                                    <InputLabel className='inputlabels'>First Name <span style={{ color: 'red' }}>*</span></InputLabel>
                                    <Controller
                                        control={control}
                                        name={"firstName"}
                                        render={({ field }) => (
                                            <TextField
                                                {...field}
                                                className='textfields'
                                                placeholder="Enter First Name"
                                                variant="outlined"
                                                type="text"
                                                size="small"
                                                sx={{
                                                    "& .MuiFormHelperText-root": {
                                                        marginLeft: '-1px'
                                                    }
                                                }}
                                                helperText={<span style={{ color: "red" }}>{errors?.firstName ? errors?.firstName?.message : ""} </span>}
                                            />
                                        )}
                                    />
                                </Grid2>

                                <Grid2 item sx={{ alignItems: 'center' }}>
                                    <InputLabel className='inputlabels'>User Type <span style={{ color: 'red' }}>*</span></InputLabel>
                                    <Box sx={{ flexGrow: 1, width: '100%' }}>
                                        <Controller
                                            control={control}
                                            name={"userType"}
                                            render={({ field }) => (
                                                <Select
                                                    {...field}
                                                    className="dropdown"
                                                    displayEmpty
                                                    IconComponent={KeyboardArrowDownIcon}
                                                    open={openSelect}
                                                    onOpen={() => setOpenSelect(true)}
                                                    onClose={() => setOpenSelect(false)}
                                                    renderValue={(selected) =>
                                                        !selected
                                                            ? <p className="menuItemsPlaceholder">Select Status</p>
                                                            : userTypeOptions?.find((name) => name?.id === selected)?.label || ''
                                                    }
                                                >
                                                    <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
                                                        <MenuItem value="" disabled> <span className="menuItemsPlaceholder"> Select Status Type</span></MenuItem>
                                                        <Tooltip
                                                            title={"Close"}
                                                            arrow
                                                        >
                                                            <IconButton size="small" onClick={() => {
                                                                setOpenSelect(false);
                                                            }}>
                                                                <ClearIcon sx={{ fontSize: '18px', color: '#a2a2a2' }} />
                                                            </IconButton>
                                                        </Tooltip>
                                                    </Box>
                                                    {userTypeOptions?.map((option) => (
                                                        <MenuItem className="menuitems" key={option?.id} value={option?.id}>
                                                            {option?.label}
                                                            {field.value === option?.id && (
                                                                <DoneIcon className="doneIcon" />
                                                            )}
                                                        </MenuItem>
                                                    ))}
                                                </Select>
                                            )}
                                        />
                                        {
                                            <div style={{ color: 'red', fontSize: '0.8rem' }}>
                                                {errors?.userType?.message}
                                            </div>
                                        }
                                    </Box>
                                </Grid2>

                                <Grid2 item sx={{ alignItems: 'center' }}>
                                    <InputLabel className='inputlabels'>City <span style={{ color: 'red' }}>*</span></InputLabel>
                                    <Controller
                                        control={control}
                                        name={"city"}
                                        render={({ field }) => (
                                            <TextField
                                                {...field}
                                                className='textfields'
                                                placeholder="Enter City"
                                                variant="outlined"
                                                size="small"
                                                sx={{
                                                    "& .MuiFormHelperText-root": {
                                                        marginLeft: '-1px'
                                                    }
                                                }}
                                                helperText={<span style={{ color: "red" }}>{errors?.city ? errors?.city?.message : ""}</span>}
                                            />
                                        )}
                                    />
                                </Grid2>

                                <Grid2 item sx={{ alignItems: 'center' }}>
                                    <InputLabel className='inputlabels'>Pincode <span style={{ color: 'red' }}>*</span></InputLabel>
                                    <Controller
                                        control={control}
                                        name={"pincode"}
                                        render={({ field }) => (
                                            <TextField
                                                {...field}
                                                className="textfields"
                                                type="number"
                                                placeholder="Enter Pincode"
                                                variant="outlined"
                                                size="small"
                                                InputProps={{
                                                    inputProps: {
                                                        maxLength: 6,
                                                        onInput: (e) => {
                                                            if (e.target.value.length > 6) {
                                                                e.target.value = e.target.value.slice(0, 6);
                                                            }
                                                        },
                                                    },
                                                }}
                                                sx={{
                                                    "& .MuiFormHelperText-root": {
                                                        marginLeft: '-1px'
                                                    },
                                                    "& input::-webkit-outer-spin-button, & input::-webkit-inner-spin-button": {
                                                        display: "none",
                                                    },
                                                }}
                                                onWheel={(e) => e.target.blur()}
                                                helperText={
                                                    <span style={{ color: "red" }}>
                                                        {errors?.pincode ? errors?.pincode?.message : ""}
                                                    </span>
                                                }
                                            />
                                        )}
                                    />
                                </Grid2>

                                <Grid2 item sx={{ alignItems: 'center', }}>
                                    <InputLabel className='inputlabels'>Contact Number<span style={{ color: 'red' }}>*</span></InputLabel>
                                    <Controller
                                        control={control}
                                        name={"mobile"}
                                        render={({ field }) => (
                                            <TextField
                                                {...field}
                                                className='textfields'
                                                type="number"
                                                placeholder="Enter Contact Number"
                                                variant="outlined"
                                                sx={{
                                                    "& .MuiFormHelperText-root": {
                                                        marginLeft: '-1px'
                                                    },
                                                    "& input::-webkit-outer-spin-button, & input::-webkit-inner-spin-button": {
                                                        display: "none",
                                                    },
                                                }}
                                                onWheel={(e) => e.target.blur()}
                                                helperText={<span style={{ color: "red" }}> {errors?.mobile ? errors?.mobile?.message : ""} </span>}
                                            />
                                        )}
                                    />
                                </Grid2>
                            </Grid2>

                            {/* Grid two starting point */}
                            <Grid2 item container rowGap={2} sx={{ display: 'flex', flexDirection: 'column', width: !isSmallScreen ? '40%' : '100%', marginTop: isSmallScreen && '15px' }}>
                                <Grid2 item sx={{ alignItems: 'center' }}>
                                    <InputLabel className='inputlabels'>Last Name <span style={{ color: 'red' }}>*</span></InputLabel>
                                    <Controller
                                        control={control}
                                        name={"lastName"}
                                        render={({ field }) => (
                                            <TextField
                                                {...field}
                                                className='textfields'
                                                placeholder="Enter Last Name"
                                                variant="outlined"
                                                size="small"
                                                sx={{
                                                    "& .MuiFormHelperText-root": {
                                                        marginLeft: '-1px'
                                                    }
                                                }}
                                                helperText={<span style={{ color: "red" }}>{errors?.lastName ? errors?.lastName?.message : ""}</span>}
                                            />
                                        )}
                                    />
                                </Grid2>

                                <Grid2 item sx={{ alignItems: 'center' }}>
                                    <InputLabel className='inputlabels'>Street/Building<span style={{ color: 'red' }}>*</span></InputLabel>
                                    <Controller
                                        control={control}
                                        name={"street"}
                                        render={({ field }) => (
                                            <TextField
                                                {...field} className='textfields'
                                                placeholder="Enter Street Building "
                                                variant="outlined"
                                                size="small"
                                                sx={{
                                                    "& .MuiFormHelperText-root": {
                                                        marginLeft: '-1px'
                                                    }
                                                }}
                                                helperText={<span style={{ color: "red" }}>{errors?.street ? errors?.street?.message : ""}</span>}
                                            />
                                        )}
                                    />
                                </Grid2>

                                <Grid2 item sx={{ alignItems: 'center' }}>
                                    <InputLabel className='inputlabels'> State <span style={{ color: 'red' }}>*</span></InputLabel>
                                    <Controller
                                        control={control}
                                        name={"state"}
                                        render={({ field }) => (
                                            <TextField
                                                {...field}
                                                className='textfields'
                                                placeholder="Enter State"
                                                variant="outlined"
                                                size="small"
                                                sx={{
                                                    "& .MuiFormHelperText-root": {
                                                        marginLeft: '-1px'
                                                    }
                                                }}
                                                helperText={<span style={{ color: "red" }}>{errors?.state ? errors?.state?.message : ""}</span>}
                                            />
                                        )}
                                    />
                                </Grid2>

                                <Grid2 item sx={{ alignItems: 'center' }}>
                                    <InputLabel className='inputlabels'> Email Id <span style={{ color: 'red' }}>*</span></InputLabel>
                                    <Controller
                                        control={control}
                                        name={"email"}
                                        render={({ field }) => (
                                            <TextField
                                                {...field}
                                                className='textfields'
                                                placeholder="Enter Email Id"
                                                variant="outlined"
                                                InputProps={editId ? { readOnly: true } : undefined}
                                                size="small"
                                                sx={{
                                                    "& .MuiFormHelperText-root": {
                                                        marginLeft: '-1px'
                                                    }
                                                }}
                                                helperText={<span style={{ color: "red" }}>{errors?.email ? errors?.email?.message : ""}</span>}
                                            />
                                        )}
                                    />
                                </Grid2>

                                <Grid2 item sx={{ alignItems: 'center' }}>
                                    <InputLabel className='inputlabels'>Status <span style={{ color: 'red' }}>*</span></InputLabel>
                                    <Box sx={{ flexGrow: 1, width: '100%' }}>
                                        <Controller
                                            control={control}
                                            name={"statusType"}
                                            render={({ field }) => (
                                                <Select
                                                    {...field}
                                                    className="dropdown"
                                                    displayEmpty
                                                    IconComponent={KeyboardArrowDownIcon}
                                                    open={openStatus}
                                                    onOpen={() => setOpenStatus(true)}
                                                    onClose={() => setOpenStatus(false)}
                                                    renderValue={(selected) =>
                                                        !selected
                                                            ? <p className="menuItemsPlaceholder">Select Status Type</p>
                                                            : statusOptions?.find((name) => name?.id === selected)?.label || ''
                                                    }
                                                >
                                                    <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
                                                        <MenuItem value="" disabled> <span className="menuItemsPlaceholder"> Select Status Type</span></MenuItem>
                                                        <Tooltip
                                                            title={"Close"}
                                                            arrow
                                                        >
                                                            <IconButton size="small" onClick={() => {
                                                                setOpenStatus(false);
                                                            }}>
                                                                <ClearIcon sx={{ fontSize: '18px', color: '#a2a2a2' }} />
                                                            </IconButton>
                                                        </Tooltip>
                                                    </Box>
                                                    {statusOptions?.map((option) => (
                                                        <MenuItem className="menuitems" key={option?.id} value={option?.id}>
                                                            {option?.label}
                                                            {field?.value === option?.id && (
                                                                <DoneIcon className="doneIcon" />
                                                            )}
                                                        </MenuItem>
                                                    ))}
                                                </Select>
                                            )}
                                        />

                                        {
                                            <div style={{ color: 'red', fontSize: '0.8rem' }}>
                                                {errors?.statusType?.message}
                                            </div>
                                        }
                                    </Box>
                                </Grid2>
                            </Grid2>
                        </Grid2>
                    </Box>
                </Box>
                <Grid2 item sx={{ display: 'flex', justifyContent: 'flex-end', gap: "20px", marginTop: "30px" }}>
                    <MUICancelButton title="Cancel" component={Link} to='/admin' />
                    <MUIButton title={"Save Changes"} type='submit' sx={{ backgroundColor: '#7F56D9', borderRadius: '7px', width: '130px' }} />
                </Grid2>
            </form>
        </Box>
    )
}
export default AddAdmin;